<div class="search-container" [loading]="loading()">
	<div class="barre-search-container mb-4">
		<label class="input input-bordered input-lg w-full gap-2">
		  <input 
		  	type="text"
		  	class="grow placeholder:text-base-content/60"
		  	placeholder="Recherchez une carte..."
		  	#searchable="searchable"
		  	[(results)]="cards"
		  	[(searching)]="loading"
		  	[search]="getSearchObs()"
		  	[(ngModel)]="qSearch"
		  	[qSearch]="qSearch()"
		  	[length]="50"
		  />
		  <span class="opacity-60"><i class="fa-light fa-sliders"></i></span>
		</label>
		<a href="#" [routerLink]="router.get('admin-form')" class="add-btn text-primary"><i class="fa-regular fa-layer-plus"></i></a>
	</div>

	<div class="card-container">
		@for(card of cards(); track card.ident){
			<a href="#" [routerLink]="router.parse('admin-card', [card.ident])" class="card mb-4">
				<img hSkeleton="250px" [altImg]="getImages(card.img)" [attr.loading]="(($index>10)? 'lazy' : null)"/>
			</a>
		}
	</div>

	<div class="pagination mt-4">
		<div class="join">
		  @if(searchable.canPrev()){
	  	  	<button (click)="searchable.prev()" class="join-item btn">«</button>
	  	  }
		  <button class="join-item btn">Page {{searchable.page()+1}}</button>
		  @if(searchable.canNext()){
		  	<button (click)="searchable.next()" class="join-item btn">»</button>
		  }
		</div>
	</div>
</div>